<template>
	<div v-if="list_webhooks.length">
		<q-item tag="label">
			<q-item-section>
				<q-item-label>Use Microsoft Teams</q-item-label>
			</q-item-section>
			<q-item-section avatar>
				<q-toggle v-model="use_microsoft_teams"/>
			</q-item-section>
		</q-item>
		<q-select
			v-if="use_microsoft_teams"
			class="padding"
			multiple
			use-input
			input-debounce="0"
			v-model="selected_teams_webhooks"
			:options="list_webhooks"
			name="Select webhooks"
			label="Select webhooks"
			:option-label="(item) => item.webhook_name"
		/>
	</div>

</template>

<script>
import { mapGetters, mapActions } from "vuex";
import MicrosoftTeamsApi from '@/services/api/MicrosoftTeams.js';
export default {
	name: 'MicrosoftTeamsRecipient',
	data(){
		return{
			list_webhooks: [],
		}
	},
	computed: {
		...mapGetters(["current_CG"]),
		use_microsoft_teams: {
			get() {
				return this.$store.getters.use_microsoft_teams
			},
			set(value) {
				if (!value){
					this.updateSelectedTeamsWebhooks([]);
				}
				this.updateUseMicrosoftTeams(value);
			}
		},
		selected_teams_webhooks: {
			get() {
				return this.$store.getters.selected_teams_webhooks
			},
			set(value) {
				this.updateSelectedTeamsWebhooks(value);
			}
		}
	},
	methods:{
		...mapActions(['updateUseMicrosoftTeams', 'updateSelectedTeamsWebhooks']),
	},
	async created(){
		this.list_webhooks = await MicrosoftTeamsApi.getMicrosoftTeamsWebhook(this.current_CG.customer_group.id, true)
	}
}
</script>
